"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultModelAssertStatusCode = exports.defaultAssertStatusCode = exports.defaultCircuitBreakerHash = void 0;
var defaultCircuitBreakerHash = function (requestConfig) {
    return [requestConfig.method, requestConfig.uri.host, requestConfig.uri.port, requestConfig.uri.path].join(':');
};
exports.defaultCircuitBreakerHash = defaultCircuitBreakerHash;
var defaultAssertStatusCode = function (statusCode) { return statusCode >= 200 && statusCode < 400; };
exports.defaultAssertStatusCode = defaultAssertStatusCode;
var defaultModelAssertStatusCode = function (assertStatusCodes) { return function (statusCode) {
    return assertStatusCodes.includes(statusCode);
}; };
exports.defaultModelAssertStatusCode = defaultModelAssertStatusCode;
//# sourceMappingURL=defaultSettings.js.map